<template>
  <el-drawer :visible.sync="mobileUserNav" direction="rtl" :with-header="false" :lock-scroll="true" :append-to-body="true" size="70%" custom-class="drawer-nav-mobile">
    <div class="head">
      <div v-if="userId" class="f--c">
        <icon-park type="User" theme="outline" size="24" fill="#333" />
        <span>{{ $store.state.common.userName }}</span>
      </div>
      <div v-else class="f--c">
        <span class="sign-in pointer" @click="jump('/login')">{{$t('Home.Register.SignIn')}}</span>
        <span style="margin:0 6px">/</span>
        <span class="sign-up pointer" @click="jump('/register')">{{$t('Home.Register.SignUp')}}</span>
      </div>
    </div>
    <div class="nav-content">
      <div class="nav-main">
        <div v-for="item in navigateList" :key="item.id" class="nav-main-item" :style="{ height: item.unfold ? `${(item.child.length + 1) * 28 +12}px` : '40px' }">
          <div class="item-bar f--c">
            <div v-if="item.imgUrl" class="img" @click="clickNav(item)">
              <p :class="{ pointer: item.linkUrl }">
                <oss-img :src="item.imgUrl" :height="25" mType="lfit" />
                <el-image v-if="item.labelImgUrl" :src="item.labelImgUrl" alt="" class="hot" />
              </p>
            </div>
            <div v-else class="name" @click="clickNav(item)">
              <p :class="{ pointer: item.linkUrl }">
                {{ item.name }}
                <el-image v-if="item.labelImgUrl" :src="item.labelImgUrl" alt="" class="hot" />
              </p>
            </div>
            <template v-if="item.child && item.child.length">
              <down v-if="!item.unfold" theme="outline" size="20" fill="#909399" @click="setBarOperation(item)"/>
              <up v-else theme="outline" size="20" fill="#909399" @click="setBarOperation(item)"/>
            </template>
          </div>
          <template v-if="item.child && item.child.length">
            <div v-for="t in item.child" :key="t.id" class="item-bar-2 f--c">
              <div v-if="t.imgUrl" class="img" @click="clickNav(t)">
                <p :class="{ pointer: t.linkUrl }">
                  <oss-img :src="t.imgUrl" :height="25" mType="lfit" />
                  <el-image v-if="t.labelImgUrl" :src="t.labelImgUrl" alt="" class="hot" />
                </p>
              </div>
              <div v-else class="name" @click="clickNav(t)">
                <p :class="{ pointer: t.linkUrl }">
                  {{ t.name }}
                  <el-image v-if="t.labelImgUrl" :src="t.labelImgUrl" alt="" class="hot" />
                </p>
              </div>
              <right v-if="t.child && t.child.length" theme="outline" size="18" fill="#909399" @click="showSecondNav(t)"/>
            </div>
          </template>
        </div>
      </div>
      <div class="nav-main" v-if="userId">
        <div  class="nav-main-item">
          <div class="item-bar f--c pointer" @click="jump('/publish/productList')">
            <div class="name">{{ $t('headerBar.wishList') }}</div>
          </div>
        </div>
        <div  class="nav-main-item">
          <div class="item-bar f--c pointer" @click="jump('/publish/listings')">
            <div class="name">{{ $t('headerBar.listing') }}</div>
          </div>
        </div>
        <div  class="nav-main-item">
          <div class="item-bar f--c pointer" @click="jump('/order/list')">
            <div class="name">{{ $t('headerBar.allOrder') }}</div>
          </div>
        </div>
      </div>
      <div class="nav-main">
        <div  class="nav-main-item">
          <div class="item-bar f--c pointer" @click="jump('/home')">
            <div class="name">GO TO KAKACLO</div>
          </div>
        </div>
        <div class="nav-main-item">
          <div class="item-bar f--c pointer" @click="jump('/help-center')">
            <div class="name">{{ $t('headerBar.helpCenter') }}</div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="userId" class="nav-signout">
      <el-button size="large" @click="logOut">{{ $t('headerBar.logOut') }}</el-button>
    </div>
    <el-drawer :visible.sync="mobileUserNav3" direction="rtl" :with-header="false" :lock-scroll="true" size="70%" modal-class="nav2-mobile">
      <div class="head">
        <div class="f--c">
          <left theme="outline" size="24" fill="#333" @click="mobileUserNav3 = false"/>
          <span @click="mobileUserNav3 = false">{{ secondNav.name }}</span>
        </div>
      </div>
      <div class="nav-content">
        <div class="nav-main">
          <div v-for="t2 in secondNav.child" :key="t2.id" class="nav-main-item" :style="{ height: t2.unfold ? `${(t2.child.length + 1) * 28 +12}px` : `40px` }">
            <div class="item-bar f--c">
              <div v-if="t2.imgUrl" class="img"  @click="clickNav(t2)">
                <p :class="{ pointer: t2.linkUrl }">
                  <oss-img :src="t2.imgUrl" :height="25" mType="lfit" />
                  <el-image v-if="t2.labelImgUrl" :src="t2.labelImgUrl" alt="" class="hot" />
                </p>
              </div>
              <div v-else class="name" @click="clickNav(t2)">
                <p :class="{ pointer: t2.linkUrl }">
                  {{ t2.name }}
                  <el-image v-if="t2.labelImgUrl" :src="t2.labelImgUrl" alt="" class="hot" />
                </p>
              </div>
              <template v-if="t2.child && t2.child.length">
                <down v-if="!t2.unfold" theme="outline" size="20" fill="#909399" @click="setBarOperation(t2, 'second')"/>
                <up v-else theme="outline" size="20" fill="#909399" @click="setBarOperation(t2, 'second')"/>
              </template>
            </div>
            <template v-if="t2.child && t2.child.length">
              <div v-for="t3 in t2.child" :key="t3.id" class="item-bar-2 f--c">
                <div v-if="t3.imgUrl" class="img" @click="clickNav(t3)">
                  <p :class="{ pointer: t3.linkUrl }">
                    <oss-img :src="t3.imgUrl" :height="25" mType="lfit" />
                    <el-image v-if="t3.labelImgUrl" :src="t3.labelImgUrl" alt="" class="hot" />
                  </p>
                </div>
                <div v-else class="name" @click="clickNav(t3)">
                  <p :class="{ pointer: t3.linkUrl }">
                    {{ t3.name }}
                    <el-image v-if="t3.labelImgUrl" :src="t3.labelImgUrl" alt="" class="hot" />
                  </p>
                </div>
              </div>
            </template>
          </div>
        </div>
      </div>
    </el-drawer>
  </el-drawer>
</template>
<script>
// import { User, Up, Down, Right, Left } from '@icon-park/vue-next'
import API from '@/api'
import { IconPark } from '@icon-park/vue/es/all'
export default {
  components: { IconPark },
  data() {
    return {
      mainDomain: process.env.VUE_APP_MAIN_DOMAIN,
      mobileUserNav: false,
      mobileUserNav3: false,
      navigateList: [],
      secondNav: {}
    }
  },
  computed: {
    userId() {
      return this.$store.state.common.userId
    }
  },
  mounted() {
    this.getNavigateList()
  },
  methods: {
    show() {
      this.mobileUserNav = true
    },
    getNavigateList() {
      this.$store.dispatch('common/customNavList').then(data => {
        this.deletechildList(data)
        this.navigateList = data
      })
    },
    deletechildList(arr) {
      arr.forEach((item) => {
        if (item.child && !item.child.length) {
          delete item.child
        } else {
          this.deletechildList(item.child)
        }
      })
    },

    showSecondNav(row) {
      this.mobileUserNav3 = true
      this.secondNav = row
    },

    setBarOperation(row, type) {
      if (type === 'second') {
        this.secondNav.child.forEach(item => {
          if (row.id === item.id) item.unfold = !item.unfold
        })
      } else {
        this.navigateList.forEach(item => {
          if (row.id === item.id) item.unfold = !item.unfold
        })
      }
    },

    // 导航跳转
    clickNav(item) {
      if (item.status === 0 || !item.linkUrl) return
      this.mobileUserNav = false
      this.mobileUserNav3 = false
      if (item.menuType === 4) location.href = item.linkUrl
      else {
        let linkUrl = item.linkUrl
        if (linkUrl.includes('/content')) linkUrl = linkUrl.replace('/content', '')
        location.href = linkUrl
        // this.getMenuCustomNav()
      }
    },
    // 导航跳转
    navLink(item) {
      if (item.status === 0 || !item.linkUrl) return ''
      if (item.menuType === 4) return item.linkUrl
      else {
        let linkUrl = item.linkUrl
        if (linkUrl.includes('/content')) linkUrl = linkUrl.replace('/content', '')
        // getMenuCustomNav()
        if (item.menuType === 2) {
          linkUrl = this.mainDomain + linkUrl
        }
        return linkUrl
      }
    },

    jump(path) {
      this.$router.push(path)
      // location.href = path
    },

    logOut() {
      API.logout().finally(() => {
        this.$store.dispatch('logOut')
      })
    }
  }
}

// const mobileUserNav = ref(false)
// const mobileUserNav3 = ref(false)
// const vuex = vuexStore()
// const userId = computed(() => {
//   return vuex.common.userId
// })

// // 获取导航条
// const navigateList = ref([])
// const getMenuCustomNav = async () => {
//   let res = await API.common.getMenuCustomNav()
//   let arr = res.data || []
//   deletechildList(arr)
//   navigateList.value = arr
// }
// const deletechildList = (arr) => {
//   if (!arr || !arr.length) return
//   arr.forEach((item) => {
//     if (item.child && !item.child.length) {
//       delete item.child
//     } else {
//       item.unfold = false
//       deletechildList(item.child)
//     }
//   })
// }

// // 打开第二导航层级
// const secondNav = ref({})
// const showSecondNav = (row) => {
//   mobileUserNav3.value = true
//   secondNav.value = row
// }

// // 展开当前行
// const setBarOperation = (row, type) => {
//   if (type === 'second') {
//     secondNav.value.child.forEach(item => {
//       if (row.id === item.id) item.unfold = !item.unfold
//     })
//   } else navigateList.value.forEach(item => {
//     if (row.id === item.id) item.unfold = !item.unfold
//   })
// }

// // 导航跳转
// const clickNav = (item) => {
//   if (item.status === 0 || !item.linkUrl) return
//   mobileUserNav.value = false
//   mobileUserNav3.value = false
//   if (item.menuType === 4) location.href = item.linkUrl
//   else {
//     let linkUrl = item.linkUrl
//     if (linkUrl.includes('/content')) linkUrl = linkUrl.replace('/content', '')
//     useRouter().push(linkUrl)
//     // location.href = item.linkUrl
//     getMenuCustomNav()
//   }
// }

// // 导航跳转
// const navLink = (item) => {
//   if (item.status === 0 || !item.linkUrl) return ''
//   if (item.menuType === 4) return item.linkUrl
//   else {
//     let linkUrl = item.linkUrl
//     if (linkUrl.includes('/content')) linkUrl = linkUrl.replace('/content', '')
//     // getMenuCustomNav()
//     if (item.menuType === 2) {
//       linkUrl = baseUrl.value + linkUrl
//     }
//     return linkUrl
//   }
// }

// // 退出登录
// const logout = () => {
//   vuex.logOut()
// }

// const jump = (path) => {
//   vuex.isPC = false
//   location.href = path
// }

// onMounted(() => {
//   getMenuCustomNav()
// })

// defineExpose({
//   mobileUserNav
// })
</script>
<style lang="scss">
.drawer-nav-mobile {
  .el-drawer__body {
    padding: 0;
    padding-left: 16px;
    padding-right: 6px;
    color: #303133;
    position: relative;
  }
  .head {
    height: 88px;
    font-size: 16px;
    padding-right: 10px;
    .i-icon {
      margin-right: 6px;
    }
    >div {
      width: 100%;
      height: 100%;
      border-bottom: 1px solid #EFF1F7;
    }
  }
  .nav-content {
    max-height: calc(100vh - 88px - 88px);
    overflow: auto;
    padding-right : 8px;
    &::-webkit-scrollbar {
      width: 6px;
    }
  }
  .nav-main {
    padding: 10px 0;
    border-bottom: 1px solid #EFF1F7;
    .nav-main-item {
      padding: 6px 0;
      overflow: hidden;
      transition: .3s;
      .item-bar, .item-bar-2 {
        width: 100%;
        height: 28px;
        .name {
          flex: 1;
        }
        .img {
          height: 28px;
          display: flex;
          align-items: center;
          flex: 1;
          img {
            height: 26px;
          }
        }
        .hot {
          position: relative;
          height: 16px;
        }

        >.i-icon {
          padding-left: 12px
        }

      }
      .item-bar-2 {
        .name {
          color: #909399;
          font-size: 13px;
        }
      }
      p {
        margin: 0;
        padding: 0;
        display: inline-block;
      }
    }
  }
  .nav-signout {
    padding: 24px 0;
    position: absolute;
    z-index: 1;
    bottom: 0;
    width: calc(100% - 32px);
    button {
      width: 100%;
    }
  }

  .nav2-mobile {
    .nav-content {
      max-height: calc(100vh - 100px);
    }
    .nav-main {
      border-bottom: 0;
    }
  }
}
</style>
